import Http from "@/commons/Http";
import VueBusiness from "@/business/VueBusiness";

const path = '/api/regras-estaduais/rj';

export const OPCOES_TIPO_FILTRO_RJ = [
  { id: 'ATOS_CERTIDOES', nome: 'Atos e Certidões' },
  { id: 'NOTA_DISTRIBUICAO', nome: 'Notas de Distribuição' },
];

export const opcoesResultado = [
  {id: 'P', nome: 'Positivo'},
  {id: 'N', nome: 'Negativo'},
  {id: 'E', nome: 'Negativo com efeito positivo'},
  {id: 'I', nome: 'Indeterminado'},
];

export default {

  dispensarImovelChecklist(tipoTribunal) {
    return VueBusiness.getVueRoot().isEstadoRJ && tipoTribunal === 'REGISTRO';
  },

  async getTiposEscritura(dominio) {
    if (dominio) {
      return Http.get(`${path}/tipos-escritura/${dominio}`);
    }
    return Http.get(`${path}/tipos-escritura`);
  },

  async getTiposAverbacao() {
    return Http.get(`${path}/tipos-averbacao`);
  },

  async getTiposRegistro() {
    return Http.get(`${path}/tipos-registro`);
  },

  async getTiposAtoDistribuicao() {
    return Http.get(`${path}/tipos-ato-distribuicao`);
  },

  async verificarRemocaoAtoDistribuicao(protocoloId, atoId) {
    return Http.get(`${path}/verificar-remocao-ato-distribuicao/${protocoloId}/${atoId}`);
  },

}
